import React from 'react';
import { Radio, RadioChangeEvent } from 'antd';

const buttonsRadius = '20px';

export enum ActiveFilter {
  ALL = 'all',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const ActiveRadioGroup: React.FC<{
  activeTab: ActiveFilter;
  changeActiveTab: (filter: ActiveFilter) => void;
}> = ({ activeTab, changeActiveTab }) => {
  const handleSetActiveTab = (e: RadioChangeEvent) => {
    changeActiveTab(e.target.value);
  };

  return (
    <Radio.Group value={activeTab} buttonStyle="solid" onChange={handleSetActiveTab}>
      <Radio.Button
        value={ActiveFilter.ALL}
        style={{ borderTopLeftRadius: buttonsRadius, borderBottomLeftRadius: buttonsRadius }}
      >
        All
      </Radio.Button>
      <Radio.Button value={ActiveFilter.INACTIVE}>Inactive</Radio.Button>
      <Radio.Button
        value={ActiveFilter.ACTIVE}
        style={{ borderTopRightRadius: buttonsRadius, borderBottomRightRadius: buttonsRadius }}
      >
        Active
      </Radio.Button>
    </Radio.Group>
  );
};
